import { Button, Typography } from '@mui/material'
import FullPageLayout from 'components/FullPageLayout/FullPageLayout'
import OrderwireLogo from 'views/CreateCompany/components/OrderwireLogo'

function LoadFailedPage() {
    return (
        <FullPageLayout>
            <>
                <OrderwireLogo />
                <Typography variant="h5">Cannot connect to server.</Typography>
                <Button
                    color="info"
                    style={{ marginTop: 24 }}
                    onClick={() => window.location.reload()}
                >
                    Retry
                </Button>
            </>
        </FullPageLayout>
    )
}

export default LoadFailedPage
